import { select, put, take } from 'redux-saga/effects';

import { tokenNeedsRefresh } from 'services/tokenService';

import { USER_LOGGED_OUT } from 'actionTypes/actionBundles';
import { refreshToken, createPartialUser } from 'actions';

function* userIdentitySaga() {
  // On start up
  const token = yield select(state => state.auth.token);
  if (token && tokenNeedsRefresh(token)) {
    yield put(refreshToken());
  }
  if (!token) {
    yield put(createPartialUser());
  }

  // Eternal
  while (true) {
    yield take(USER_LOGGED_OUT);
    yield put(createPartialUser());
  }
}

export default userIdentitySaga();



// WEBPACK FOOTER //
// ./src/sagas/eternalSagas/userIdentitySaga.js